import React from 'react';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { Form } from '@ant-design/compatible';
import { Input } from 'antd';

const sanitizeFieldName = (name) => name.replace(/[^a-zA-Z0-9]/g, '_');

export const getCustomFieldsForAPI = (values, customFields) => {
	const customFieldDetails = (customFields || []).map((field) => ({
		key: values[`custom-${sanitizeFieldName(field.fieldName)}-fieldName`],
		valueType: values[`custom-${sanitizeFieldName(field.fieldName)}-valueType`],
		valueAsString: values[`custom-${sanitizeFieldName(field.fieldName)}-valueAsString`],
	}));
	return customFieldDetails;
};

export default function CustomFieldItems({ getFieldDecorator, form, formData, customFields }) {
	if (!formData || !formData.id || nullSafeGet('length', customFields) < 0) {
		return null;
	}

	return customFields.map((field) => {
		getFieldDecorator(`custom-${sanitizeFieldName(field.fieldName)}-fieldName`, {
			initialValue: field.fieldName,
		});
		getFieldDecorator(`custom-${sanitizeFieldName(field.fieldName)}-valueType`, {
			initialValue: field.type || field.fieldType,
		});

		return (
			<Form.Item label={field.fieldName} key={field.fieldName}>
				{form.getFieldDecorator(`custom-${sanitizeFieldName(field.fieldName)}-valueAsString`, {
					validateTrigger: ['onChange', 'onBlur'],
					initialValue:
						(
							nullSafeGetOrElse('customFieldDetails', formData, []).find(
								(i) => i.key === field.fieldName
							) || {}
						).valueAsString || '',
				})(<Input style={{ maxWidth: 640 }} />)}
			</Form.Item>
		);
	});
}
